import { useKnowledgeBaseUpdateKnowledgeAgentUpdatePostMutation } from '@shared/api';

export const useAgentKnowledgeBase = () => {
  const [updateMutation, { isLoading: isUpdating }] =
    useKnowledgeBaseUpdateKnowledgeAgentUpdatePostMutation();

  const updateKnowledgeBase = async (agentId: number, knowledgeBaseIds: number[]) => {
    await updateMutation({
      bodyKnowledgeBaseUpdateKnowledgeAgentUpdatePost: {
        agent_id: agentId,
        knowledge_base_files: knowledgeBaseIds,
      },
    }).unwrap();
  };

  return {
    updateKnowledgeBase,
    isUpdating,
  };
};
